import { Injectable } from '@angular/core';
import {
  EventCustomerValidationStatus,
  EventCustomerValidationType
} from '../../models/_enum-collections';
import { EventPaymentInformationModel } from '../../models/event-payment-information.model';
import {
  EventRegistrationModel,
  EventRegistrationCustomerModel
} from '../../models/event-registration.model';

@Injectable({
  providedIn: 'root'
})
export class FakeDataService {
  loadFakeEventRegistrationData(): EventRegistrationModel[] {
    const result: EventRegistrationModel[] = [];

    const max = this.generateRandomInt(100);
    for (let i = 0; i < max; i++) {
      result.push({
        eventRegistrationId: i,
        eventRegistrationBatchId: 'sdadadsadsaada',
        eventTypeId: 1,
        eventType: 'M365 for business workshop',
        eventStatusName: 'Approved',
        eventStatusId: 1,
        l1InternalStatusName: 'Approved',
        l2InternalStatusName: 'Approved',
        fiscalYear: 2021,
        partnerMpnid: this.generateRandomInt(100000),
        partnerOrgName: `Partner${i}`,
        eventDetailId: 1,
        eventName: 'eventName',
        requestDate: new Date(),
        facilitatorName: 'test',
        facilitatorCountryName: 'ttesrs',
        isMultiTargetProductSupported: false,
        eventRegistrationDocuments: []
      });
    }

    return result;
  }

  loadFakeEventRegistrationCustomerData(
    eventRegistrationId: number
  ): EventRegistrationCustomerModel[] {
    const result: EventRegistrationCustomerModel[] = [];

    const max = this.generateRandomInt(10);
    for (let i = 0; i < max; i++) {
      result.push({
        eventRegistrationId,
        eventCustomerId: i,
        eventCustomerValidationStatusId: EventCustomerValidationStatus.Approved,
        eventCustomerValidationTypeId: EventCustomerValidationType.TenantID,
        reason: `reason${i}`,
        customerName: this.generateRandomString(10),
        tenantId: this.generateRandomString(5),
        dbNumber: this.generateRandomString(5),
        webUrl: this.generateRandomString(5),
        tpId: this.generateRandomString(5),
        customerCountry: this.generateRandomString(5)
      });
    }

    return result;
  }

  loadFakeEventPaymentInformation(): EventPaymentInformationModel {
    const result: EventPaymentInformationModel = {
      eventCompletionDate: this.generateRandomDate(),
      eventTypeCompleted: 'M365 for business workshop',
      eventTypeCompletedId: 1,
      expectedPaymentMonthId: 363,
      expectedPaymentMonth: 'September, 2019',
      partnerPaymentProfileStatus: true,
      payeeId: this.generateRandomString(5),
      agreement: false,
      confidence: 'Received',
      confidenceId: 4,
      expectedPOEDate: this.generateRandomDate(),
      msInvoiceNumber: this.generateRandomString(5),
      msInvoicePaidDate: this.generateRandomDate(),
      payeeName: this.generateRandomString(5),
      submittedDate: this.generateRandomDate(),
      supplierId: this.generateRandomString(5),
      paymentCentralTransactionId: this.generateRandomString(5),
      statementNumber: this.generateRandomString(5),
      partnerStatementSentDate: this.generateRandomDate(),
      scheduledEventDate: this.generateRandomDate(),
      eventTargetProductName: '',
      eventTargetProductId: 0,
      isMultiTargetProductSupported: false,
      milestoneOneCompletionDate: ''
    };

    return result;
  }

  generateRandomInt(max = 10, min = 1): number {
    return parseInt((Math.random() * (max - min) + min).toString(), 0);
  }

  generateRandomString(length: number) {
    let result = '';
    const characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  generateRandomDate() {
    const minYear = 1900;
    const maxYear = 2021;
    const maxMonth = 12;
    const maxDay = 28;
    return `${this.generateRandomInt(maxYear, minYear)}-${this.generateRandomInt(maxMonth)}-${this.generateRandomInt(maxDay)} 00:00:00.000`;
  }
}
